import React from 'react'
import { Tooltip } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { TubeProduct } from '../enum'
import { BiTubeProduct } from '../../BiTube/enum'
import InfoIcon from '@material-ui/icons/Info'
import { useGetProduct } from '@src/routes/Configurators/utils/useGetProduct'

const useStyles = makeStyles((theme: Theme) => {
  return {
    InfoPopup: {
      maxWidth: theme.spacing(65),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      boxShadow: theme.shadows[4],
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.black,
      borderRadius: '2%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    arrow1: {
      color: theme.palette.common.white,
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      verticalAlign: 'middle',
    },
    InfoIcon: {
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5),
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
    },
    arrow: {
      color: theme.palette.common.white,
    },
  }
})
const OligoNameInfoIcon = () => {
  const classes = useStyles()
  const product = useGetProduct()

  return (
    <div>
      <span className={classes.label}>
        {' '}
        {<FormattedMessage {...messages[`CONF_OLIGO_NAME_${product}`]} />}
      </span>
      {product === TubeProduct.Standard ||
      TubeProduct.Rna ||
      TubeProduct.Probe ||
      TubeProduct.Wellred ||
      TubeProduct.Cpeptide ||
      BiTubeProduct.LightCycler ? (
        <Tooltip
          title={<FormattedMessage {...messages.CONF_DNA_OLIGO_NAME_TOOLTIP} />}
          classes={{ tooltip: classes.InfoPopup, arrow: classes.arrow }}
          arrow
          placement="bottom-end"
        >
          <InfoIcon
            aria-label="info"
            className={classes.InfoIcon}
            color="primary"
          ></InfoIcon>
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  )
}

export default OligoNameInfoIcon
